import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import style from './styles/style.module.css';
import { PrimaryButton, DLTextField, DLRichTextEditor } from 'appSrc/components/UI';

class SiteCopyForm extends PureComponent {
    constructor( props ) {
        super( props );
        var page = '';
        var section = '';
        var copy_text = '';

        if( this.props.initialValues ) {
            var pageName = this.props.initialValues.name ? this.props.initialValues.name.split( ':' ) : ['',''];
            if( pageName[ 0 ] ){
                page = pageName[ 0 ].split( '_' )
                .join( ' ' );
            }
            if( pageName[ 1 ] ){
                section = pageName[ 1 ].split( '_' )
                .map( word => ( word.charAt( 0 ).toUpperCase() + word.slice( 1 ) ) )
                .join( ' ' );
            }

            copy_text = this.props.initialValues.copy_text;
        }


        this.state = {
            page: page,
            section: section,
            copy_text: copy_text,
        };
    }
    correctTitles = ( str ) => {
        str = str.toLowerCase()
        .replace( ' ', '_' )
        .replace( /:/g, '' )
        .split( '_' )
        .join( ' ' );

        return str;
    }
    updatePage = ( e, { value } ) => {
        this.setState( { page: this.correctTitles( value ) } );
    }
    updateSection = ( e, { value } ) => {
        this.setState( { section: this.correctTitles( value ) } );
    }
    updateCopy = ( value ) => {
        this.setState( { copy_text: value } );
    }
    submit = () => {
        var name = this.state.page.toLowerCase().trim().replace( ' ', '_' ).replace( /:/g, '' );
        name += ':' + this.state.section.toLowerCase().trim().replace( ' ', '_' ).replace( /:/g, '' );
        var data = {
            name: name,
            copy_text: this.state.copy_text,
        };
        this.props.onSubmit( data );
    }
    render() {
        const { page, section, copy_text } = this.state;
        var valid = !!page && !!section && copy_text;
        return (
            <div className={ style.copyForm }>
                <DLTextField
                name="page"
                label="Page Name"
                disabled={ this.props.edit }
                onChange={ this.updatePage }
                value={ page }
                fullWidth
                required />

                <DLTextField
                name="section"
                label="Section Name"
                disabled={ this.props.edit }
                onChange={ this.updateSection }
                value={ section }
                fullWidth
                required />

                <DLRichTextEditor label='Copy Text'
                value={ copy_text } onChange={ this.updateCopy } />

                <PrimaryButton
                label="Submit"
                fullWidth
                type="submit"
                onClick={ this.submit }
                disabled={ !valid }
                style={ { marginTop: '15px' } }/>
            </div>
        );
    }
}
SiteCopyForm.defaultProps = {
    initialValues: null,
    onSubmit: ()=>{},
};


export default connect()( SiteCopyForm );
